import { useCallback } from 'react';
import {
  AlertStatus,
  useToast as useChakraToast,
  UseToastOptions as UseChakraToastOptions,
} from '@chakra-ui/react';

export type UseToastOptions = {
  status: AlertStatus;
  description: string;
};

const TOAST_OPTIONS = {
  info: { title: 'INFO', duration: 5000 },
  warning: { title: 'WARNING', duration: 5000 },
  success: { title: 'SUCCESS', duration: 5000 },
  error: { title: 'ERROR', duration: null },
  loading: { title: 'LOADING', duration: null },
} as const;

export const useToast = () => {
  const toast = useChakraToast();

  return useCallback(
    (options: UseToastOptions) => {
      const defaultOptions: UseChakraToastOptions = {
        position: 'top-right',
        duration: 5000,
        isClosable: true,
      };

      toast({
        ...defaultOptions,
        ...options,
        title: TOAST_OPTIONS[options.status].title,
        duration: TOAST_OPTIONS[options.status].duration,
      });
    },
    [toast],
  );
};
